import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdefa118"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner-text"
}




export default /*#__PURE__*/_defineComponent({
  props: {
  size: {
    type: String,
    default: 'medium',
    validator(value) {
      return ['small', 'medium', 'large'].indexOf(value as string) !== -1;
    },
  },
  text: { type: String, default: '' },
  center: { type: Boolean, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`spinner-wrapper ${__props.center ? 'spinner-wrapper__center' : ''}`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`spinner is-${__props.size}`)
    }, null, 2),
    (__props.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})